import { api } from "@/lib/axios";
import type {
  ApiResponse,
  ManagerListResult,
  ManagerDetail,
  UpdateManagerRequest,
  InsertManagerRequest,
} from "../types/manager.types";

export const getDispatchManagers = async (
  companyGuid: string,
): Promise<ManagerListResult> => {
  const { data } = await api.get<ApiResponse<ManagerListResult>>(
    `/api/Account/Admin/Dispatch-Managers/${companyGuid}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const getDispatchManager = async (
  accountGuid: string,
): Promise<ManagerDetail> => {
  const { data } = await api.get<ApiResponse<ManagerDetail>>(
    `/api/Account/Admin/Dispatch-Manager/${accountGuid}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const updateDispatchManager = async (
  params: UpdateManagerRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/Account/Admin/Dispatch-Manager/Update",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
};

export const insertDispatchManager = async (
  params: InsertManagerRequest,
): Promise<{ accountGuid: string }> => {
  const { data } = await api.post<ApiResponse<{ accountGuid: string }>>(
    "/api/Account/Admin/Dispatch-Manager/Insert",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};
